
import { Edge } from '@xyflow/react';

export const initialEdges: Edge[] = [];
